export const SITE_INFO = {
  name: "G28 ApS",
  shortName: "G28 ApS",
  logo: "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/g28-nyt-logo-rez.png",
  phone: "+45 51 51 91 17",
  phoneDisplay: "51 51 91 17",
  email: "sh@g28.dk",
  address: "Ole Rømers Vej 32, 8670 Låsby",
  cvr: "45155765",
  openingHours: "Mandag - Fredag: 07.00 - 16.00",
  tagline: "Kvalitetstømrer & Snedkermester",
  description: "G28 ApS udfører kvalitetsbyggeri, tagarbejde, specialløsninger og totalrenovering for private boligejere og erhverv.",
  instagram: "https://www.instagram.com/___g28___",
  instagramHandle: "@___g28___"
};

export const FALLBACK_SERVICES = [
  {
    id: "c8b34e32",
    title: "Tagarbejde & Tagrenovering",
    url_slug: "tagarbejde",
    short_description: "Nyt tag, kviste og tagrenovering udført med største præcision, god isolering og lang holdbarhed.",
    full_description: "<p>Et tæt og veludført tag er boligens vigtigste beskyttelse mod det danske klima. Vi tilbyder komplet tagarbejde – fra oplægning af nye tegltage, skifertage og ståltage til udskiftning af undertag, isolering, kviste og tagrender.</p><p>Vores uddannede tømrere rådgiver om den optimale konstruktion og materialevalg, så dit nye tag både matcher husets arkitektur og overholder de nyeste krav til energioptimering.</p>",
    icon: "fa-solid fa-house-chimney-window",
    featured_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_f493eae0.jpeg"],
    meta_title: "Tagarbejde & Tagrenovering - G28 ApS",
    meta_description: "Professionelt tagarbejde og komplet tagrenovering i høj kvalitet af faguddannede tømrere. Indhent uforpligtende tilbud på nyt tag."
  },
  {
    id: "4c09f266",
    title: "Døre & Vinduer",
    url_slug: "doere-og-vinduer",
    short_description: "Energioptimering og udskiftning af elementer, vinduer og yderdøre tilpasset din boligs arkitektur.",
    full_description: "<p>Nye døre og vinduer forbedrer indeklimaet, sænker varmeregningen og løfter husets samlede æstetiske udtryk. Vi hjælper med udskiftning og montering af alt fra klassiske dannebrogsvinduer til moderne sprossede glaspartier og specialfremstillede træ/alu-løsninger.</p><p>Hvert element tilpasset præcist til boligens mål og arkitektoniske linjer for at sikre optimal tæthed og et stilrent resultat.</p>",
    icon: "fa-solid fa-door-open",
    featured_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00002_80f10c1c.jpeg"],
    meta_title: "Døre & Vinduer - Udskiftning og Montering - G28 ApS",
    meta_description: "Professionel montering af døre og vinduer. Få professionel rådgivning og udskiftning af energirigtige vinduer og døre."
  },
  {
    id: "59fff80d",
    title: "Specialløsninger",
    url_slug: "specialloesninger",
    short_description: "Skræddersyede træløsninger, pladsbyggede reoler og unikt håndværk tilpasset dit hjem.",
    full_description: "<p>Specialløsninger er for dig, der søger skræddersyede træløsninger ud over det sædvanlige. Vi designer og fremstiller pladsbyggede reoler, garderober, akustikpaneler og arkitektoniske detaljer i massive sorter som egetræ, valnød og douglasgran.</p><p>Med sans for detaljen og dyb respekt for materialet skaber vi unikke elementer, der passer perfekt til dit hjems rumlige dimensioner.</p>",
    icon: "fa-solid fa-ruler-combined",
    featured_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00030.jpeg"],
    meta_title: "Specialløsninger & Pladsbyggede Løsninger - G28 ApS",
    meta_description: "Pladsbyggede reoler, træpaneler og skræddersyede løsninger udført i massive træsorter af erfarne håndværkere."
  },
  {
    id: "00e5ddfd",
    title: "Træterrasser & Uderum",
    url_slug: "traeterrasser",
    short_description: "Eksklusive træterrasser udført i holdbare træsorter med skjulte samlinger og stilrent finish.",
    full_description: "<p>En veldesignet træterrasse forlænger sommeren og skaber en sømløs overgang mellem bolig og have. Vi opbygger eksklusive træterrasser i modstandsdygtige træsorter som varmebehandlet thermowood, ipé, cumaru og hårdttræ.</p><p>Fra fundering og bærende bjælkelag til usynlige skruemontager og integrerede trapper leverer vi håndværk i særklasse.</p>",
    icon: "fa-solid fa-layer-group",
    featured_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00005_92491bb2.jpeg"],
    meta_title: "Eksklusive Træterrasser & Uderum - G28 ApS",
    meta_description: "Opbygning af eksklusive træterrasser i hårdttræ, thermo-ask og lærketræ. Holdbare og smukke løsninger til haven."
  },
  {
    id: "8e875846",
    title: "Renovering & Ombygning",
    url_slug: "renovering-ombygning",
    short_description: "Ombygning, tilbygning og renovering af klassiske og moderne boliger med stor respekt for arkitekturen.",
    full_description: "<p>Planlægger du en større ombygning, loftetageudnyttelse eller en gennemgribende renovering af din bolig? Vi varetager både delentrepriser og hovedentrepriser i tæt samarbejde med arkitekter og ingeniører.</p><p>Vi koordinerer alle faggrupper, overholder tidsplanen og sikrer, at husets sjæl bevares samtidig med, at komforten og energirammen løftes til moderne standarder.</p>",
    icon: "fa-solid fa-hammer",
    featured_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_33a66958.jpeg"],
    meta_title: "Totalrenovering & Ombygning - G28 ApS",
    meta_description: "Gennemgribende ombygning og renovering af huse og lejligheder med tømrerfaglig kvalitet i højsædet."
  },
  {
    id: "ca3b71e6",
    title: "Køkken & Bad",
    url_slug: "koekken-og-bad",
    short_description: "Håndbyggede snedkerkøkkener og præcis montering i ege- og kvalitetstræ.",
    full_description: "<p>Et specialbygget køkken i massivt træ kombinerer enestående funktionalitet med varig æstetik. Vi fremstiller og monterer håndbyggede snedkerkøkkener med skuffesystemer i egetræ, massive bordplader og gennemtænkte skabsløsninger.</p><p>Uanset om du vil have montering af et præfabrikeret køkken eller et unikt håndlavet snedkerkøkken, sikrer vi knivskarp præcision i alle samlinger.</p>",
    icon: "fa-solid fa-kitchen-set",
    featured_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_5076a762.jpeg"],
    meta_title: "Specialbyggede Køkkener - G28 ApS",
    meta_description: "Skræddersyede snedkerkøkkener og kvalitetstømrerarbejde i køkken og bad med sans for detaljer og materialevalg."
  },
  {
    id: "3e9add4e",
    title: "Fundament- og murerarbejde",
    url_slug: "fundament-og-murerarbejde",
    short_description: "Hos G28 ApS får du professionelt fundament- og murerarbejde, hvor kvalitet, præcision og godt håndværk er i fokus.",
    full_description: "<p>Hos <strong>G28 ApS</strong> får du professionelt fundament- og murerarbejde, hvor kvalitet, præcision og godt håndværk er i fokus. Vi sørger for, at arbejdet bliver udført rigtigt fra starten – så du får et solidt og holdbart resultat, der holder i mange år.</p><p>Vi udfører blandt andet <strong>fundamenter, sokler, terrændæk, støbearbejde, opmuring, skalmuring, facadeisolering, puds samt renovering og omfugning</strong>.</p><p>Uanset om du bygger nyt, laver en tilbygning eller renoverer, finder vi den rigtige løsning til dit projekt og sørger for, at arbejdet bliver planlagt og udført ordentligt.</p><p><strong>Du får én professionel samarbejdspartner, klare aftaler og en skriftlig pris – fra første spadestik til det færdige resultat.</strong></p><p><strong>G28 ApS – solidt håndværk, gennemtænkte løsninger og kvalitet, du kan bygge videre på</strong></p>",
    icon: "fa-solid fa-trowel-bricks",
    featured_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00009_708e730d.jpeg"],
    meta_title: "Fundament- og Murerarbejde - G28 ApS",
    meta_description: "Professionelt fundament- og murerarbejde. Støbning af fundament, sokkel, terrændæk og kvalitetsmurerarbejde i høj faglig standard hos G28 ApS."
  },
  {
    id: "c9614148",
    title: "Nybyg",
    url_slug: "nybyg",
    short_description: "Totalentrepriser og opførelse af moderne, arkitekttegnede villaer, sommerhuse og enfamiliehuse fra råjord til indflytning.",
    full_description: "<p>Drømmer du om at opføre et kompromisløst nybyggeri? Hos G28 ApS realiserer vi eksklusive, arkitekttegnede villaer, enfamiliehuse og moderne sommerhuse med stor respekt for materialer, æstetik og holdbare løsninger.</p><p>Vi påtager os gerne totalentreprisen eller hovedentreprisen på dit nybyggeri. Det betyder, at vi styrer og koordinerer hele forløbet: fra jord- og betonarbejde, støbning af fundament og opførelse af råhus til tømrer- og snedkerarbejde, tagkonstruktion, vinduesmontage og den fineste indvendige aptering. Med G28 ApS har du én fast kontaktperson gennem hele byggeprocessen, hvilket giver gennemskuelighed, tryghed og tæt dialog.</p><p>Vi bygger boliger med fokus på fremtidssikret energieffektivitet, smukke detaljer i træ og murværk samt højeste håndværksmæssige standard – altid afleveret til aftalt tid og aftalt pris.</p>",
    icon: "fa-solid fa-building",
    featured_image: [],
    meta_title: "Nybyg & Nybyggeri - Arkitekttegnede Huse - G28 ApS",
    meta_description: "Opførelse af eksklusivt nybyggeri, arkitekttegnede villaer og moderne sommerhuse. G28 ApS leverer totalløsninger med høj faglig præcision."
  }
];

export const FALLBACK_PROJECTS = [
  {
    id: "7d8815af",
    title: "Arkitekttegnet Villa – Vesterlundvej",
    url_slug: "arkitekttegnet-villa-vesterlundvej",
    service_slug: "renovering-ombygning",
    location: "Vesterlundvej 73B",
    year: "2024",
    description: "Moderne enfamiliehus opført i to niveauer med facader i rustfarvet cortenstål og trælameller. Projektet rummer store panoramavinduer, indre atriumgårdhave, specialbyggede snedkerløsninger og integreret pejs.",
    cover_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/edit-20260901t094720-cfabfb3e-16bit.png"],
    gallery_images: [
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/edit-20260901t094720-cfabfb3e-16bit.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/edit-20260901t093954-51416d20-16bit.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/edit-20260901t093250-4bb9cfa3-16bit.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_e9ce881e.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_3eec7aef.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00004_8bec3892.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00005_587ca986.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00006_8f136537.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00007_13e8aebf.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00014_2fcc1f8b.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-15-47-54-ps-copy.jpg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-15-45-51.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-15-42-03.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-14-08-15-int-04.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-15-38-10.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-15-35-53.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-15-34-11.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-15-32-31.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-15-27-24.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-15-44-59.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/enscape-2022-02-04-15-44-14.png"
    ],
    meta_title: "Arkitekttegnet Villa på Vesterlundvej - G28 ApS",
    meta_description: "Moderne villa i cortenstål og træ med atriumgårdhave og panoramavinduer udført af G28 ApS."
  },
  {
    id: "8435c34e",
    title: "Sommerhus Hornbæk – Til- og Ombygning",
    url_slug: "sommerhus-hornbaek-til-og-ombygning",
    service_slug: "traeterrasser",
    location: "Hornbæk",
    year: "2026",
    description: "Gennemgribende til- og ombygning af moderne sort træsommerhus i Hornbæk. Etablering af stor sammenhængende træterrasse med integreret havebassin/swimmingpool, sprossevinduer og overdækket uderum.",
    cover_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/edit-20260901t091033-116779d5-16bit.png"],
    gallery_images: [
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/edit-20260901t091033-116779d5-16bit.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image1-000.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image1-001.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image1-002.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image1.png"
    ],
    meta_title: "Sommerhus Hornbæk – Til- og Ombygning - G28 ApS",
    meta_description: "Til- og ombygning af sommerhus i Hornbæk med sort træbeklædning, træterrasse og swimmingpool."
  },
  {
    id: "dd5274ee",
    title: "Moderne Landejendom – Gl. Randersvej, Stilling",
    url_slug: "moderne-landejendom-stilling-skanderborg",
    service_slug: "renovering-ombygning",
    location: "Stilling, Skanderborg",
    year: "2026",
    description: "Moderne landejendom opført med markant mørk træbeklædning, lys muret skorsten og store glaspartier i harmonisk samspil med det omgivende naturlandskab.",
    cover_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/skilt-03-photoshop-rez_5e315522.jpg"],
    gallery_images: [
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/skilt-03-photoshop-rez_5e315522.jpg"
    ],
    meta_title: "Moderne Landejendom i Stilling, Skanderborg - G28 ApS",
    meta_description: "Nybygget landejendom i Stilling med mørk træbeklædning og store vinduespartier."
  },
  {
    id: "23af9294",
    title: "totalrenovering af lejlighed - Amicisvej, Frederiksberg",
    url_slug: "tagetage-koekkenalrum-amicisvej-frederiksberg",
    service_slug: "koekken-og-bad",
    location: "Frederiksberg",
    year: "2026",
    description: "Omfattende renoveringsopgave på Frederiksberg med etablering af lyst køkken-alrum på loftsétage med fritlagte tagspær, ovenlysvinduer, specialfremstillet køkkenø og integreret pejs.",
    cover_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/00-koekkenalrum-000.png"],
    gallery_images: [
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/00-koekkenalrum-000.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/01-koekkenalrum.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/02-koekkenalrum-000.png",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00037.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_6255a921.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00002_99c62c61.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_ff72a93b.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00004_5f760505.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00005_1d5ec9bc.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00006_4a4fb30d.jpeg"
    ],
    meta_title: "totalrenovering af lejlighed - Amicisvej, Frederiksberg - G28 ApS",
    meta_description: "Totalrenovering og etablering af loftsétage med synlige bjælker og snedkerkøkken på Frederiksberg."
  },
  {
    id: "f239e060",
    title: "Arkitekttegnet Villa - Ry",
    url_slug: "arkitekttegnet-villa-ry",
    service_slug: "nybyg",
    location: "Ry",
    year: "2026",
    description: "Opførelse og tømrerarbejde på eksklusiv arkitekttegnet villa i Ry med fokus på gennemtænkte trædetaljer, flot finish og kompromisløse kvalitetsmaterialer.",
    cover_image: ["https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00007_cfc6e796.jpeg"],
    gallery_images: [
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00007_cfc6e796.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00001_4f45d34b.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00002_1b4a323a.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00003_a179bcca.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00004_e8ca01f6.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00005_1c996b17.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00006_a6edc7eb.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00008_60748105.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00009_13165f84.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00010_7117777a.jpeg",
      "https://assets.auxodev.dk/assets/58b18d64-1cfa-413a-b5ba-90838c1f6d2c/image00011_d659d709.jpeg"
    ],
    meta_title: "Arkitekttegnet Villa - Ry - G28 ApS",
    meta_description: "Eksklusivt tømrer- og byggearbejde på arkitekttegnet villa i Ry udført af G28 ApS."
  }
];

export const FALLBACK_REVIEWS = [
  {
    id: "rev1",
    author: "Mette & Christian Poulsen",
    role_or_location: "Hellerup",
    rating: 5,
    comment: "G28 ApS har udført et helt eminent stykke arbejde på vores villa. Fra første rådgivningsmøde til den sidste fejekost var oplevelsen tryg, tidsplanen overholdt og finish i absolut verdensklasse.",
    date: "2026-02-14"
  },
  {
    id: "rev2",
    author: "Lars Lindegaard",
    role_or_location: "Nordsjælland",
    rating: 5,
    comment: "Faglighed ud over det sædvanlige! Vores nye tag og kviste står knivskarpt. Kommunikationen undervejs var klar og gennemskuelig. Kan kun give min varmeste anbefaling.",
    date: "2026-01-20"
  },
  {
    id: "rev3",
    author: "Henrik Vejle",
    role_or_location: "Lyngby",
    rating: 5,
    comment: "Specialsnedkeriet på vores reolvæg og egekøkken har forvandlet hele vores stue. Man kan virkelig mærke kærligheden til træfaget. Præcision i absolut topklasse!",
    date: "2025-11-05"
  },
  {
    id: "rev4",
    author: "Camilla & Thomas Berg",
    role_or_location: "Vedbæk",
    rating: 5,
    comment: "Kæmpe ros herfra. Vores nye thermo-ask terrasse blev færdig til tiden og overgik alle forventninger. Yderst professionelle håndværkere der rydder pænt op efter sig.",
    date: "2025-09-18"
  },
  {
    id: "rev5",
    author: "Morten Skov",
    role_or_location: "Gentofte",
    rating: 5,
    comment: "Nye energivinduer og døre monteret perfekt. Ingenting blev overladt til tilfældighederne. Klart det bedste tømrerfirma vi har benyttet.",
    date: "2025-08-30"
  }
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Første Dialog & Besigtigelse",
    description: "Møde på adressen og fagmæssig rådgivning om din løsning."
  },
  {
    step: "02",
    title: "Gennemskueligt Tilbud",
    description: "Skriftligt tilbud med fast pris, tidsplan og materialevalg."
  },
  {
    step: "03",
    title: "Præcis Udførelse",
    description: "Kvalitetsarbejde udført af faguddannede håndværkere."
  },
  {
    step: "04",
    title: "Aflevering & Oprydning",
    description: "Gennemgang af arbejdet og ryddelig aflevering."
  }
];

export const FALLBACK_JOBS = [
  {
    id: "toemrersvend",
    title: "Erfaren Tømrersvend til kvalitetsbyggeri",
    url_slug: "toemrersvend-kvalitetsbyggeri",
    job_type: "Fuldtid (37 t/uge)",
    location: "Låsby, Aarhus & Midtjylland",
    short_description: "Er du udlært tømrer med sans for detaljen og lyst til alsidige opgaver på arkitekttegnede huse og renoveringer? Bliv en del af G28.",
    description: "<p>Hos G28 ApS søger vi en erfaren og fagligt stolt tømrersvend, der brænder for kvalitetsbyggeri, præcision og gennemtænkte løsninger. Vi arbejder med spændende projekter som arkitekttegnede villaer, totalrenoveringer, tagkonstruktioner og specialløsninger i træ.</p><p>Du bliver en del af et team på byggepladser i Øst- og Midtjylland, hvor vi vægter godt humør, gensidig respekt og faglig stolthed højt. Vi tilbyder egen veludstyret firmabil, førsteklasses værktøj og stor frihed under ansvar.</p>",
    requirements: "Udlært tømrer eller bygningssnedker;Kørekort B;Erfaring med renovering og nybyg;Kvalitetsbevidst og mødestabil",
    order: 1,
    is_active: true
  },
  {
    id: "toemrerlaerling",
    title: "Ambitiøs Tømrerlærling (Voksenlærling / Ordinær)",
    url_slug: "toemrerlaerling",
    job_type: "Fuldtid (Læreplads / Uddannelsesaftale)",
    location: "Låsby & omegn",
    short_description: "Vil du have en læreplads, hvor du lærer det rigtige håndværk af erfarne mestre på spændende byggerier? Søg lærlingeplads hos G28.",
    description: "<p>Drømmer du om at lære det ægte tømrerfag fra bunden hos fagfolk, der virkelig går op i håndværk og detaljer? Hos G28 ApS tager vi lærlinge seriøst. Hos os er du ikke bare fejedreng – du får en grundig oplæring i klassisk tømrerarbejde, moderne energirenovering og præcisionssnedkeri.</p><p>Vores mestre har tilsammen over 35 års erfaring, som vi glæder os til at give videre til dig. Vi søger både ordinære lærlinge og voksenlærlinge, som er mødestabile, nysgerrige og klar til at tage fat.</p>",
    requirements: "Bestået GF2 eller god motivation for faget;Mødestabil og ansvarsbevidst;Lyst til at lære og samarbejde;Kørekort B er en fordel",
    order: 2,
    is_active: true
  },
  {
    id: "uopfordret",
    title: "Uopfordret Ansøgning – Tømrer eller Snedker",
    url_slug: "uopfordret-ansoegning",
    job_type: "Fuldtid / Projektansættelse",
    location: "Øst- og Midtjylland",
    short_description: "Har du hænderne skruet rigtigt på og en passion for kompromisløst træhåndværk? Send en uopfordret ansøgning til G28.",
    description: "<p>Vi er altid på udkig efter dygtige, passionerede håndværkere og fagfolk, der kan styrke vores hold. Uanset om du er specialiseret tømrer, bygningssnedker eller byggeleder, vil vi meget gerne høre fra dig, hvis du deler vores værdier om gennemsigtighed, kvalitet og ordentlighed.</p><p>Send os en kort beskrivelse af dig selv og dine erfaringer, eller grib knoglen og ring til os for en uformel snak.</p>",
    requirements: "Relevant faglig baggrund;Faglig stolthed;Selvstændig og løsningsorienteret",
    order: 3,
    is_active: true
  }
];

